import { DEFAULT_COUNTRY } from '../../../config/constants';
import User from '../../../models/User';
import { IAction } from '../../models/action.model';
import { FETCH, REMOVE, SAVE, UPDATE } from './actionTypes';

const defaultStore: User = {
  id: 0,
  email: '',
  token: '',
  hubspotVisitorToken: '',
  countryCode: DEFAULT_COUNTRY,
  avatarBase64Encoded: null,
  profile: undefined,
  countMessage: 0,
};

export default function user(state: User = defaultStore, action: IAction) {
  switch (action.type) {
    case SAVE:
      return {
        id: action.payload.id,
        email: action.payload.email,
        countryCode: action.payload.countryCode,
        token: action.payload.token,
        hubspotVisitorToken: action.payload.hubspotVisitorToken,
        avatarBase64Encoded: action.payload.avatarBase64Encoded,
        profile: action.payload.profile,
        countMessage: action.payload.countMessage,
        verticals: action.payload.verticals,
      };

    case FETCH:
      return {
        ...state,
      };

    case UPDATE:
      return {
        ...state,
        ...action.payload,
      };

    case REMOVE:
      return {
        ...state,
        ...defaultStore,
      };

    default:
      return state;
  }
}
